
import store from "../store";
import * as types from "./constants";

export function getAvatars() {
  const url = urls.get('ajax_event_avatars', {
    event_id: window.evite_event.id,
    gid: window.guest_id
  });
  window.$.get(url, (response) => {
    store.dispatch({
      type: types.ADD_AVATARS,
      avatars: response
    });
  })
}



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/avatars/actions.es6